// extracted by mini-css-extract-plugin
export var questionBox = "_65-0";